import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Chip from "@mui/material/Chip";
import { between } from "../style/style";
import { alpha, IconButton, useMediaQuery, useTheme } from "@mui/material";
import { BackIcon } from "@ui/assets/custom-icons/back-icon";
import { Link as RouterLink } from "react-router-dom";
/**
 * Generic page header component with title, optional subtitle, and right-aligned actions.
 */
export const PageHeader = ({ title, subtitle, breadcrumbs: breadcrumbItems, actions, startActions, center, actions2, children, onBack, }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
    const toolbarMode = !title && !subtitle;
    return (React.createElement(Box, { sx: Object.assign(Object.assign({ gap: 1 }, between), { background: (t) => t.palette.background.default, flex: 1, pb: 1, flexWrap: isMobile ? "wrap" : "nowrap" }) },
        (title || subtitle) && (React.createElement(Box, { sx: {
                display: "flex",
                alignItems: "center",
                gap: isMobile ? 1 : 2,
                flex: isMobile ? "0 0 100%" : center ? "0 0 auto" : 1,
                minWidth: 0,
            } },
            onBack && (React.createElement(IconButton, { size: "large", style: {
                    color: theme.palette.tertiary.main,
                    border: `1px solid ${alpha(theme.palette.primary.main, 0.4)}`,
                }, onClick: onBack },
                React.createElement(BackIcon, null))),
            React.createElement(Box, { sx: {
                    display: "flex",
                    flexDirection: "column",
                    flex: 1,
                    minWidth: 0,
                } },
                React.createElement(Box, { sx: {
                        display: "flex",
                        alignItems: "center",
                        flexWrap: "wrap",
                        columnGap: 2,
                        rowGap: 0.5,
                        minWidth: 0,
                    } },
                    React.createElement(Typography, { variant: "h3", sx: {
                            fontWeight: 500,
                            color: "#000c1a",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        } }, title),
                    subtitle &&
                        (() => {
                            const colonIdx = subtitle.indexOf(": ");
                            if (colonIdx !== -1) {
                                const label = subtitle.slice(0, colonIdx);
                                const value = subtitle.slice(colonIdx + 2);
                                return (React.createElement(Box, { sx: {
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1,
                                        // Never squeezed by a long title: the title ellipsises
                                        // instead.
                                        flexShrink: 0,
                                    } },
                                    React.createElement(Typography, { sx: {
                                            fontSize: 13,
                                            fontWeight: 400,
                                            color: "text.secondary",
                                            whiteSpace: "nowrap",
                                        } },
                                        label,
                                        ":"),
                                    React.createElement(Chip, { label: value, size: "medium", sx: {
                                            backgroundColor: "#00244D1F",
                                            color: "#00244D",
                                            fontWeight: 500,
                                            fontSize: 12,
                                            borderRadius: "24px",
                                            height: 32,
                                            pointerEvents: "none",
                                            "& .MuiChip-label": { px: 1 },
                                        } })));
                            }
                            return (React.createElement(Typography, { sx: {
                                    fontSize: 13,
                                    color: "text.secondary",
                                    flexShrink: 0,
                                } }, subtitle));
                        })()),
                breadcrumbItems && breadcrumbItems.length > 0 && (React.createElement(Breadcrumbs, { "aria-label": "breadcrumb", separator: "\u2192", sx: {
                        mt: 0.5,
                        "& .MuiBreadcrumbs-separator": {
                            mx: 1,
                            color: "text.disabled",
                        },
                        "& .MuiBreadcrumbs-li": {
                            "& > *": {
                                fontSize: "0.75rem",
                                fontWeight: 400,
                                color: "text.disabled",
                            },
                        },
                        "& .MuiBreadcrumbs-li:last-of-type > *": {
                            color: "text.secondary",
                        },
                    } }, breadcrumbItems.map((item, index) => {
                    const isLast = index === breadcrumbItems.length - 1;
                    if (item.path && !isLast) {
                        return (React.createElement(Link, { key: index, component: RouterLink, to: item.path, underline: "hover", color: "inherit", sx: {
                                "&:hover": { color: "primary.main" },
                            } }, item.label));
                    }
                    return (React.createElement(Typography, { key: index, component: "span", variant: "body2" }, item.label));
                }))),
                children))),
        center && React.createElement(Box, { sx: { flex: 1, minWidth: 0 } }, center),
        startActions && (React.createElement(Box, { sx: {
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                gap: 1.5,
                flex: toolbarMode ? 1 : "0 0 auto",
                minWidth: 0,
            } }, startActions)),
        actions && (React.createElement(Box, { sx: {
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                gap: 1.5,
                width: isMobile
                    ? toolbarMode && startActions
                        ? "auto"
                        : "100%"
                    : "auto",
            } }, actions)),
        actions2 && (React.createElement(Box, { sx: {
                display: "flex",
                alignItems: "center",
                gap: 1,
            } }, actions2))));
};
